import {
  Box,
  Spinner,
  useToast
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { FaWrench } from "react-icons/fa";

import { useConversationsApi } from "src/api";
import { Header } from "src/components/shared/Header";
import { Text } from "src/components/text";
import { useAuthContext } from "src/hooks/useAuthContext";
import { QuickActionBox } from "src/pages/home/components/QuickActionBox";

export const ScriptsPage: React.FC = () => {
  const { authDataState } = useAuthContext();
  const [ migrateConversationsRes, migrateConversationsReq ] = useConversationsApi("MIGRATE_CONVERSATION_TYPES");
  const toast = useToast();

  useEffect(() => {
    // Migrate conversation types
    if (migrateConversationsRes.complete && !migrateConversationsRes.error) {
      toast({
        status: "success",
        title: "Statuses have been migrated successfully."
      });
    }

    if (migrateConversationsRes.error) {
      toast({
        status: "error",
        title: "There was an error."
      });
    }
  }, [ migrateConversationsRes, toast ]);

  return (
    <Box p={10}>
      <Header />

      {!authDataState.user ? <Spinner /> : (

        <Box
          paddingY={25}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >

          <Box
            display="flex"
            padding={5}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Text
              as="p"
              bold
            >
              Scripts
            </Text>
          </Box>

          <Box
            marginY={25}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection="row"
          >
            <QuickActionBox
              Icon={FaWrench}
              text="Migrate conversation statuses"
              handleClick={() => migrateConversationsReq({})}
            />

          </Box>
        </Box>
      )}

    </Box>
  );
};
